import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';
import Person from '../../models/Person';


export interface PersonDetailState extends ApiState {
  person?: Person
}

export default requestReducer<PersonDetailState>('PERSON_DETAIL')
